export const WEBSITE_DOMAIN_PATH = "-books.giuliacrm.com"
export const TEST_DOMAIN = "-books.elsif.in"
